import React, { memo, useCallback, useMemo } from 'react'
import { Form, Formik } from 'formik'
import type { LmsTrainingPlain } from 'src/interfaces/collectStepReference'
import { LmsTrainingFormContent } from './LmsTrainingFormContent'
import { lmsTrainingFormValidator } from './LmsTrainingForm.validator'
import type { LmsTrainingFormMode, LmsTrainingFormValues } from './LmsTrainingForm.interface'

interface Props {
  formId: string
  mode: LmsTrainingFormMode
  lmsTraining: LmsTrainingPlain | null
  onSubmit(values: LmsTrainingFormValues): void
}

const LmsTrainingFormComponent = ({ formId, mode, lmsTraining, onSubmit }: Props) => {
  const initialValues = useMemo<LmsTrainingFormValues>(() => {
    return {
      // The stored value is a number; the form holds it as a string. `?? ''` rather than a
      // falsy check so a legitimate externalId of 0 seeds as '0', not ''.
      externalId: lmsTraining?.externalId?.toString() ?? '',
      url: lmsTraining?.url ?? '',
      title: lmsTraining?.title ?? '',
      description: lmsTraining?.description ?? '',
      manualUploadRequirements: lmsTraining?.manualUploadRequirements ?? '',
    }
  }, [lmsTraining])

  const handleSubmit = useCallback(
    (values: LmsTrainingFormValues) => {
      onSubmit(values)
    },
    [onSubmit],
  )

  return (
    <Formik<LmsTrainingFormValues>
      initialValues={initialValues}
      validationSchema={lmsTrainingFormValidator}
      // Reopening the modal on a different row must reseed the fields.
      enableReinitialize
      onSubmit={handleSubmit}
    >
      <Form id={formId}>
        <LmsTrainingFormContent mode={mode} />
      </Form>
    </Formik>
  )
}

export const LmsTrainingForm = memo(LmsTrainingFormComponent)
